import { render, staticRenderFns } from "./CompTableSettingsDialog.vue?vue&type=template&id=5df64fda&scoped=true"
import script from "./CompTableSettingsDialog.vue?vue&type=script&lang=js"
export * from "./CompTableSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./CompTableSettingsDialog.vue?vue&type=style&index=0&id=5df64fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df64fda",
  null
  
)

export default component.exports